import React, { useCallback } from 'react'
import { ConfirmationDialog } from '@paintscout/ui'
import { useCrmDialogs } from '@paintscout/ui-business'

export function useConfirmBeforeCancel({
  confirmBeforeCancelWhenDirty,
  isFormDirty,
  onCancel
}: {
  confirmBeforeCancelWhenDirty: boolean
  isFormDirty: boolean
  onCancel?: (event?: React.MouseEvent<HTMLElement>) => any
}) {
  const { openDialog, dismissDialog } = useCrmDialogs()

  const handleRequestCancel = useCallback(
    (event?: React.MouseEvent<HTMLElement>) => {
      if (confirmBeforeCancelWhenDirty && isFormDirty) {
        openDialog(ConfirmationDialog, {
          message: React.createElement(
            'span',
            null,
            'You have unsaved changes. Are you sure you want to exit without saving?'
          ),
          onConfirm: async () => {
            dismissDialog()
            onCancel?.()
          },
          onCancel: dismissDialog
        })
        return
      }

      onCancel?.(event)
    },
    [confirmBeforeCancelWhenDirty, dismissDialog, isFormDirty, onCancel, openDialog]
  )

  return handleRequestCancel
}
